import FormArchives from '../../DAL/FormArchives'
import { getDocs, collection } from 'firebase/firestore'
import {store} from '../utilities'

export default function readRubrics(archiveId) {
  return function () {
    if (!archiveId) return
    async function fetch() {
      const formArchives = new FormArchives()
      const snap = await getDocs(collection(formArchives.docRef(archiveId), 'rubrics'))
      const rMap = {}
      snap.docs.forEach((d) => {
        rMap[d.id] = {id: d.id, ...d.data()}
      })
      store.dispatch({type: 'rubrics', payload: rMap})
    }
    fetch()
  }
}
